var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-container',{staticClass:"main-content-container px-4",attrs:{"fluid":""}},[_c('page-header',{attrs:{"title":"Usuário","subTitle":"Editar"}}),(_vm.user)?_c('user-account-details',{ref:"userForm",attrs:{"isCurrentUser":_vm.isUserLogged}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }